/**
 * This file is auto-generated from CheckboxEditable.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const editableCheckboxText: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Editable checkbox text';
        case 'pl':
            return 'Edytowalny tekst pola wyboru';
    }
};
